"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var clone = require('clone');

var tv4 = require('tv4');

var Card = require('./card');

var ConditionCard = /*#__PURE__*/function (_Card) {
  _inherits(ConditionCard, _Card);

  var _super = _createSuper(ConditionCard);

  function ConditionCard(opt) {
    var _this;

    _classCallCheck(this, ConditionCard);

    _this = _super.call(this, opt);
    _this.type = 'CONDITION';
    _this.details = {
      cards: [],
      conditions: {},
      description: null,
      header: '',
      title: null,
      value: null
    };

    if (opt && opt.details) {
      _this.fillObject(clone(opt.details));
    }

    return _this;
  }

  _createClass(ConditionCard, [{
    key: "getOptions",
    value: function getOptions() {
      return Object.keys(this.details.conditions);
    }
  }, {
    key: "setCondition",
    value: function setCondition(value) {
      this.fillCards(this.details.conditions[value]);
    }
  }, {
    key: "fillObject",
    value: function fillObject(details) {
      this.details.conditions = details.conditions || {};
      this.details.description = details.description || null;
      this.details.header = details.header || '';
      this.details.title = details.title || null;
      this.details.value = details.value || null;
      this.fillCards(details.cards);
      this.isValid = !!this.details.value && !this.details.cards.some(function (c) {
        return !c.isValid;
      });
    }
  }, {
    key: "fillCards",
    value: function fillCards(cards) {
      if (Array.isArray(cards)) {
        var _require = require('../../helper/card-factory'),
            createCardFactory = _require.createCardFactory; // eslint-disable-line


        this.details.cards = cards.map(function (card) {
          return createCardFactory(card.type, _objectSpread({}, card));
        });
      }
    }
  }, {
    key: "calculateCounts",
    value: function calculateCounts(count) {
      var result = _objectSpread({}, count);

      this.details.cards.forEach(function (card) {
        if (card.details.countLabel) {
          result[card.details.countLabel] = (result[card.details.countLabel] || 0) + card.details.count;
        }
      });
      return result;
    }
  }, {
    key: "validate",
    value: function validate() {
      return tv4.validateMultiple(this, ConditionCard.schema());
    }
  }], [{
    key: "schema",
    value: function schema() {
      return {
        $schema: 'http://json-schema.org/draft-04/schema#',
        id: 'condition-card.schema.json',
        type: 'object',
        allOf: [{
          $ref: 'card.schema.json'
        }, {
          properties: {
            details: {
              conditions: {
                type: 'object'
              },
              cards: {
                type: 'array',
                items: {
                  type: 'object'
                }
              },
              description: {
                type: ['string', 'null']
              },
              header: {
                type: 'string'
              },
              title: {
                type: ['string', 'null']
              },
              value: {
                type: ['string', 'null']
              }
            }
          }
        }],
        required: Object.keys(this)
      };
    }
  }]);

  return ConditionCard;
}(Card);

tv4.addSchema(Card.schema());
module.exports = ConditionCard;